module.exports = __webpack_public_path__ + "img/video_bg.c4d2ac4c.png";